<header class="page_header">
  <div class="header_content">
    <div class="text_and_supporting_text">
      <div class="page_title">Item Filing</div>
    </div>
    <div class="action_btn">
      <button class="add_new_btn" (click)="addNewRecord()">
        <img src="assets/icons/plus_icon.svg" height="20" width="20">Add New Item
      </button>
    </div>
  </div>
</header>

<app-tos-table
        [showTableStats]="false"
        [tableMeta]="tableMeta"
        [defaultFilters]="itemConfig.defaultFilters"
        [filterConfig]="itemConfig.filterConfig"
        [searchBarConfig]="itemConfig.searchBarConfig"
        [tableMenuOptions]="menuOptions"
        [(dataListRequest)]="tableListRequest"
        [dataListResponse]="tableListData"
        [(allTableRecordsSelected)]="allTableRecordsSelected"
        [(selectedItems)]="selectedItems"
        (tosTableAction)="fetchAllRecords()"
        (tableMenuOptionSelected)="handleMenuOptionSelection($event)"
></app-tos-table>

